module.exports = __webpack_public_path__ + "src/img/material.a507a76d.svg";